import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Box from 'grommet/components/Box'
import Hero from 'grommet/components/Hero'
import Heading from 'grommet/components/Heading'
import Image from 'grommet/components/Image'
import Paragraph from 'grommet/components/Paragraph'

import Footer from '../components/Footer'
import Header from '../components/Header'
import MenuItems from '../components/menus/MenuItems'
import BlowoutMenuItem from '../components/menus/BlowoutMenuItem'
import ModalMenuItem from '../components/menus/ModalMenuItem'
import ActionLinks from '../components/ActionLinks'

import '../styles/OverviewMenu.css'

class OverviewMenu extends Component {
  _renderBackgroundImage () {
    const {
      backgroundImage
    } = this.props.data

    if (backgroundImage) {
      return <Image src={backgroundImage} fit='cover' full />
    }
  }

  render () {
    const {
      history,
      data
    } = this.props

    const {
      title,
      subtitle,
      backgroundImage,
      menuItems,
      actionLinks
    } = data

    let hasImageClass = backgroundImage ? 'has-image' : ''

    const menuCards = menuItems.filter((menuItem) => {
      return !menuItem.isSpecial
    })

    const specialCards = menuItems.filter((menuItem) => {
      return menuItem.isSpecial
    })

    return (
      <div className={`OverviewMenu ${hasImageClass}`}>
        <Hero background={backgroundImage ? this._renderHeroBackground() : null}>
          <Header bg={backgroundImage ? null : 'primary-1'} />

          <Box align='center' margin={{top: 'large'}}>
            <Heading margin='none' strong>{title}</Heading>
            <Paragraph align='center' size='large'>{subtitle}</Paragraph>
            <ActionLinks links={actionLinks} history={this.props.history} />
          </Box>
        </Hero>

        <div className='item-container'>
          <MenuItems menuItems={menuCards} itemComponent={BlowoutMenuItem} history={history} />
        </div>

        <div className='modal-item-container'>
          <MenuItems menuItems={specialCards} itemComponent={ModalMenuItem} history={this.props.history} />
        </div>

        <Footer
          isRoot={this.props.isRoot}
          history={history} />
      </div>
    )
  }

  _renderHeroBackground = () => {
    return (
      <div>
        <Image src={this.props.data.backgroundImage} fit='cover' full />
        <Image src='/images/inline/Overlay.png' className='overlay' />
      </div>
    )
  }
}

OverviewMenu.propTypes = {
  data: PropTypes.object,
  history: PropTypes.object,
  isRoot: PropTypes.bool
}

export default OverviewMenu



// WEBPACK FOOTER //
// ./src/layouts/OverviewMenu.js